import { List, ShowButton, useTable } from '@refinedev/antd';
import { Button, Form, Input, Table } from 'antd';
import { HttpError } from '@refinedev/core';
import { IChild, IChildFilterVariables } from '../../interfaces/child';
import { IUser } from '../../interfaces/user';

export const ChildList = () => {
  const { tableProps, searchFormProps } = useTable<IChild, HttpError, IChildFilterVariables>({
    sorters: {
      initial: [
        {
          field: 'createdAt',
          order: 'desc',
        },
      ],
    },
    meta: {
      fields: [
        'id',
        'userId',
        {
          user: ['id', 'email'],
        },
        'name',
        'gender',
        'birthday',
        'currentType',
      ],
    },
    onSearch: (params) => {
      const { id } = params;
      return [
        {
          field: 'id',
          operator: 'eq',
          value: id,
        },
      ];
    },
  });

  const SearchForm = () => (
    <Form layout="inline" {...searchFormProps}>
      <Form.Item label="ID" name="id">
        <Input placeholder="ID" />
      </Form.Item>
      <Button htmlType="submit" type="primary">
        検索
      </Button>
    </Form>
  );

  return (
    <List resource="children" headerProps={{ title: '子供一覧' }} headerButtons={<SearchForm />}>
      <Table
        {...tableProps}
        rowKey="id"
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total) => `全${total}件`,
        }}
      >
        <Table.Column<IChild>
          dataIndex={['user', 'email']}
          title="親"
          render={(email: IUser['email'], record) => (email ? email : `匿名(${record.userId})`)}
        />
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column dataIndex="gender" title="Gender" />
        <Table.Column dataIndex="birthday" title="Birthday" />
        <Table.Column dataIndex="currentType" title="タイプ" />
        <Table.Column<IChild>
          dataIndex="actions"
          render={(_, record) => <ShowButton hideText size="small" recordItemId={record.id} />}
        />
      </Table>
    </List>
  );
};
